import { createThemeCompiler } from '../../../utils';

export const dateRangePickerThemeCompiler = createThemeCompiler(({ stroke }) => ({
    dateRangePicker: {
        colors: {
            sectionDividerColor: '#DDDBDA',
            calloutBorderColor: '#DDDBDA'
        },
        composites: {
            calloutBorderWidth: stroke.thin,
            calloutBorderStyle: 'solid'
        }
    }
}));
